<template>
  <div class="container" v-if="leftBoxShow" :style="{ 'background-image': `url(${MenuImg}`, color: `${leftBoxColor}` }">
     <div class="search">
         <input type="text" v-model="minput" @change="filterMenu(minput)" style="height: 32px;padding-left: 20px;font-size: 16px;z-index: 99;" @blur="showPlaceholder = true" @focus="showPlaceholder = false"  class="minput"/>
         <div class="placeholder" v-if="showPlaceholder && !minput"><i class="iconfont"  style="font-size: 14px;color: rgba(255,255,255,0.8) !important;">&#xe600;</i><span style="font-size: 12px;margin-left: 4px;line-height: 18px;color: #ffffffCC;margin-bottom: 2px;">搜索...</span></div>
     </div>
     <div class="menuList">
        <div class="menu-item"  v-for="(item, index) in menuList" :key="index" >
           <menu-Item  :items="item" :level="1" :key="index" :nowPath="nowPath" />
        </div>
     </div>
  </div>
</template>
<script>
import '../../../font/search/demo.css'
import '../../../font/search/iconfont.css'
import menuItem from './menuItem.vue'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['MenuImg', 'leftBoxColor', 'leftBoxShow', 'nowPath'])
  },
  components: {
    menuItem,
  },

  data () {
    return {
      minput: '',
      showPlaceholder: true,
      menuList: JSON.parse(localStorage.getItem('Menu')).menuData ? JSON.parse(localStorage.getItem('Menu')).menuData : []
    }
  },
  methods: {
    filterMenu (val) {
      if (val) {
        this.menuList = this.menuList.filter(item => {
          console.log(item.meta.title)
          return item.meta.title.includes(val)
        })
      } else {
        //此处需要等接口返回菜单重新赋值
        this.menuList = this.objTemp
      }

    }
  },
  mounted () {
    // this.menuList = menuData


  }

}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  width: 220px !important;

  .search {
    height: 50px;
    padding: 10px 30px 0 10px;
    display: flex;
    align-content: center;
    position: relative;

    .placeholder {
      position: absolute;
      display: flex;
      justify-content: center;
      top: 16px;
      left: 32px;
      align-items: center;
    }

    .minput {
      background: transparent;
      color: rgba(255, 255, 255, .8);
      border: none !important;
      padding-left: 20px !important;
      padding-top: 10px;
    }
  }

  .menuList {
    flex: 1;
    width: 100%;

    .menu-item {
      display: flex;
      width: 100%;
    }
  }
}

input {
  outline: none;
  padding: 0 !important;
}

input::placeholder {
  color: rgba(255, 255, 255, .8);
}

//at.alicdn.com/t/c/font_1826843_998n70vh72t.css
</style>



// WEBPACK FOOTER //
// src/views/homePage/leftBox/menu.vue